import React, { useEffect, useRef } from "react";
import { paintDecorationCanvas } from "./ShareCardDecorations";

export default function ShareDecorationPreview({ element, scene, pixelRatio = 1, style, surfaces }) {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    const resolution = Math.min(3, window.devicePixelRatio || 1) * pixelRatio;
    paintDecorationCanvas(canvas, element, scene, resolution, 96, 768, surfaces);
  }, [element, scene, pixelRatio, surfaces]);
  return <canvas ref={canvasRef} className="share-editor-decoration-art" style={style} aria-hidden="true" />;
}
